const PlayButton = props => (
  <svg viewBox="0 0 105 105" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Play Button</title>
    <circle cx="52.5" cy="52.5" r="49.5" />
    <path d="M77 52.5l-39 21v-42z" />
  </svg>
);

export { PlayButton };
